export const TOKEN_NAME = process.env.REACT_APP_TOKEN_NAME
export const NOT_AUTH = process.env.REACT_APP_NOT_AUTH
export const EXPIRY_PASS = process.env.REACT_APP_EXPIRY_PASS
export const CACHE_ROUTE = process.env.REACT_APP_CACHE_ROUTE
export const APP_SUB_MENU = "ME_CORE_APP_SUB_MENU";
export const ME_CORE_CACHE = 'ME_CORE_CACHE'